import { StatusBadge } from "./StatusBadge";
import { Clock } from "lucide-react";

export function StatusTimeline({ logs = [] }) {
  if (logs.length === 0) {
    return (
      <div className="text-sm text-muted-foreground border border-dashed border-border rounded-lg p-8 text-center bg-white">
        <Clock className="h-6 w-6 mx-auto mb-2 text-slate-300" />
        Sin cambios de estatus registrados.
      </div>
    );
  }
  return (
    <div className="relative pl-6" data-testid="status-timeline">
      <div className="absolute left-2.5 top-2 bottom-2 w-px bg-border" />
      <ol className="space-y-5">
        {logs.map((l) => (
          <li key={l.id} className="relative">
            <span className="absolute -left-4 top-1 h-3 w-3 rounded-full bg-tenant border-4 border-white shadow-sm" />
            <div className="text-xs text-muted-foreground">
              {l.created_at?.slice(0, 16).replace("T", " ")}
              {l.changed_by_name && <> · {l.changed_by_name}</>}
            </div>
            <div className="mt-1 flex items-center gap-2 text-sm">
              {l.previous_status && (
                <>
                  <StatusBadge status={l.previous_status} className="opacity-70" />
                  <span className="text-muted-foreground">→</span>
                </>
              )}
              <StatusBadge status={l.new_status} />
              {l.new_stage_name && (
                <span className="text-xs text-slate-600" data-testid={`timeline-stage-${l.id}`}>
                  {l.previous_stage_name ? `${l.previous_stage_name} → ` : ""}{l.new_stage_name}
                  {l.event === "flow_change" ? " (cambio de flujo)" : l.event === "auto" ? " (automático)" : ""}
                </span>
              )}
            </div>
            {l.notes && <p className="text-sm text-slate-700 mt-1.5">{l.notes}</p>}
          </li>
        ))}
      </ol>
    </div>
  );
}
